/**
 * Represents errors that occur during application execution.
 */
var _Exception_innerException;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
export default class Exception extends Error {
    constructor(message, innerException) {
        super(message);
        _Exception_innerException.set(this, void 0);
        const trueProto = new.target.prototype;
        // Alternatively use Object.setPrototypeOf if you have an ES6 environment.
        this.__proto__ = trueProto;
        __classPrivateFieldSet(this, _Exception_innerException, innerException, "f");
    }
    /** Gets the Exception instance that caused the current exception. */
    get innerException() {
        return __classPrivateFieldGet(this, _Exception_innerException, "f");
    }
    static isException(error) {
        if (error instanceof Exception) {
            return true;
        }
        else if (error instanceof Object) {
            return error['innerException'] !== undefined;
        }
        return false;
    }
}
_Exception_innerException = new WeakMap();
